import { z } from 'zod';

import { sharedStructuredEventShape } from './shared';

export const PRESENT_CLARIFY_OPTIONS_TOOL_ID = 'presentClarifyOptions';

export const clarifyOptionSchema = z.object({
    headline: z.string(),
    subline: z.string().optional(),
});

export type ClarifyOptionPayload = z.infer<typeof clarifyOptionSchema>;

export const presentClarifyOptionsPayloadSchema = z.object({
    message: z.string(),
    options: z.array(clarifyOptionSchema).min(1),
});

export type PresentClarifyOptionsPayload = z.infer<typeof presentClarifyOptionsPayloadSchema>;

export const clarifyOptionsResponseEventSchema = z.object({
    ...sharedStructuredEventShape,
    payload: presentClarifyOptionsPayloadSchema,
    toolId: z.literal(PRESENT_CLARIFY_OPTIONS_TOOL_ID),
});

export type ClarifyOptionsResponseEvent = z.infer<typeof clarifyOptionsResponseEventSchema>;
